import Big from "big.js";   


export const VATRatePerCountry: Record<string, {
  percent: Big;
  applyCoeff: Big;
  applyExtractCoeff: Big;
  reverseExtractCoeff: Big;
  reverseCoeff: Big;
}> = {
  FR: {
    percent: new Big(20),
    applyCoeff: new Big(1.2),
    applyExtractCoeff: new Big(0.2),
    reverseCoeff: new Big(1).div(1.2),
    reverseExtractCoeff: new Big(0.2).div(1.2),
  },
  DE: {
    percent: new Big(19),
    applyCoeff: new Big(1.19),
    applyExtractCoeff: new Big(0.19),
    reverseCoeff: new Big(1).div(1.19),
    reverseExtractCoeff: new Big(0.19).div(1.19),
  },
  IT: {
    percent: new Big(22),
    applyCoeff: new Big(1.22),
    applyExtractCoeff: new Big(0.22),
    reverseCoeff: new Big(1).div(1.22),
    reverseExtractCoeff: new Big(0.22).div(1.22),
  },
  ES: {
    percent: new Big(21),
    applyCoeff: new Big(1.21),
    applyExtractCoeff: new Big(0.21),
    reverseCoeff: new Big(1).div(1.21),
    reverseExtractCoeff: new Big(0.21).div(1.21),
  },
  BE: {
    percent: new Big(21),
    applyCoeff: new Big(1.21),
    applyExtractCoeff: new Big(0.21),
    reverseCoeff: new Big(1).div(1.21),
    reverseExtractCoeff: new Big(0.21).div(1.21),
  },
  NL: {
    percent: new Big(21),
    applyCoeff: new Big(1.21),
    applyExtractCoeff: new Big(0.21),
    reverseCoeff: new Big(1).div(1.21),
    reverseExtractCoeff: new Big(0.21).div(1.21),
  },
  PT: {
    percent: new Big(23),
    applyCoeff: new Big(1.23),
    applyExtractCoeff: new Big(0.23),
    reverseCoeff: new Big(1).div(1.23),
    reverseExtractCoeff: new Big(0.23).div(1.23),
  },
  IE: {
    percent: new Big(23),
    applyCoeff: new Big(1.23),
    applyExtractCoeff: new Big(0.23),
    reverseExtractCoeff: new Big(0.23).div(1.23),
    reverseCoeff: new Big(1).div(1.23),
  },
  AT: {
    percent: new Big(20),
    applyCoeff: new Big(1.2),
    applyExtractCoeff: new Big(0.2),
    reverseExtractCoeff: new Big(0.2).div(1.2),
    reverseCoeff: new Big(1).div(1.2),
  },
  CH: {
    percent: new Big(8.1),
    applyCoeff: new Big(1.081),
    applyExtractCoeff: new Big(0.081),
    reverseExtractCoeff: new Big(0.081).div(1.081),
    reverseCoeff: new Big(1).div(1.081),
  },
  HU: {
    percent: new Big(27),
    applyCoeff: new Big(1.27),
    applyExtractCoeff: new Big(0.27),
    reverseExtractCoeff: new Big(0.27).div(1.27),
    reverseCoeff: new Big(1).div(1.27),
  },
  FI: {
    percent: new Big(25.5),
    applyCoeff: new Big(1.255),
    applyExtractCoeff: new Big(0.255),
    reverseExtractCoeff: new Big(0.255).div(1.255),
    reverseCoeff: new Big(1).div(1.255),
  },
  PL: {
    percent: new Big(23),
    applyCoeff: new Big(1.23),
    applyExtractCoeff: new Big(0.23),
    reverseExtractCoeff: new Big(0.23).div(1.23),
    reverseCoeff: new Big(1).div(1.23),
  },
  CZ: {
    percent: new Big(21),
    applyCoeff: new Big(1.21),
    applyExtractCoeff: new Big(0.21),
    reverseExtractCoeff: new Big(0.21).div(1.21),
    reverseCoeff: new Big(1).div(1.21),
  },
  DK: {
    percent: new Big(25),
    applyCoeff: new Big(1.25),
    applyExtractCoeff: new Big(0.25),
    reverseExtractCoeff: new Big(0.25).div(1.25),
    reverseCoeff: new Big(1).div(1.25),
  },
  SI: {
    percent: new Big(22),
    applyCoeff: new Big(1.22),
    applyExtractCoeff: new Big(0.22),
    reverseExtractCoeff: new Big(0.22).div(1.22),
    reverseCoeff: new Big(1).div(1.22),
  },
  LU: {
    percent: new Big(16),
    applyCoeff: new Big(1.16),
    applyExtractCoeff: new Big(0.16),
    reverseExtractCoeff: new Big(0.16).div(1.16),
    reverseCoeff: new Big(1).div(1.16),
  },
}